import { render, staticRenderFns } from "./RelQuestion.vue?vue&type=template&id=27af2978"
import script from "./RelQuestion.vue?vue&type=script&lang=js"
export * from "./RelQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports